import React from "react";
import { useState } from "react";
import Layout from "../component/common/Layout/Layout";
import SpeedChart from "../component/common/Chart/SpeedChart";

import { Wrapper } from "@googlemaps/react-wrapper";
import FleetViewMap from "./FleetViewMap";
import { DeviceIcon } from "../assets/digital_twin_icons/digitalTwinIcons";
import {
  BandwidthIcon,
  CloudImg,
  Count,
  DownIcon,
  ErrorIcon,
  Notification,
  SmartHome,
  TimeIcon,
  UpIcon,
  DoubleAero,
  Connectedcheck,
  Deviceslog,
  Networkround,
  Listing,
} from "../assets/AllSvg";

import connectedDevicesIcon from "../assets/digital_twin_icons/Connected Devices.svg";
import gatewatIcon from "../assets/digital_twin_icons/Gateway.svg";
import signalIcon from "../assets/digital_twin_icons/Average signal strength.svg";
import ProductOriginIcon from "../assets/digital_twin_icons/Product_Origin.svg";
import DeviceInfoIcon from "../assets/digital_twin_icons/Device_Info.svg";
import CurrentChannelIcon from "../assets/digital_twin_icons/Current_Channel.svg";
import byteAndErrorIcon from "../assets/digital_twin_icons/Byte and error.svg";

// img import
import deviceBLue from "../assets/images/conectDevice/device-blue.svg";
import deviceGray from "../assets/images/conectDevice/device-gray.svg";
import deviceYellow from "../assets/images/conectDevice/device-yellow.svg";

import line from "../assets/images/conectDevice/bulbLine.svg";
import home from "../assets/images/conectDevice/home.svg";
import home2 from "../assets/images/conectDevice/home2.svg";
import router from "../assets/images/conectDevice/router.svg";
import wifi from "../assets/images/conectDevice/wifi.svg";
import Device from "../components/Device";
import Button from "../components/Button";

const DigitalTwin = () => {
  const [modal, setModal] = useState(false);
  const mapKey = process.env.REACT_APP_VITE_MAP_KEY;

  return (
    <Layout>
      <div className="flex flex-col p-5 gap-5 dark:bg-[#1d1d1d]">
        <h1 className="text-dark1 text-2xl dark:text-white">
          Real time status
        </h1>

        <div className="bg-white w-full rounded-xl flex gap-5 p-5 justify-between dark:bg-box-pattern2">
          <QualityExperienceCard />
          <NotificationsCard />
          <MapCard modal={modal} mapKey={mapKey} />
        </div>
        <div className="flex gap-5 justify-between">
          <DeviceProfileCard />
          <ConnectedDevicesProfileCard />
        </div>
      </div>
    </Layout>
  );
};

export default DigitalTwin;

const QualityExperienceCard = () => {
  return (
    <div className="flex flex-col flex-1 justify-between p-5 gap-5 bg-white rounded-xl shadow-xl dark:bg-[#444444] items-center ">
      <h1 className="h1 text-center dark:text-white">Quality of experience</h1>
      <SpeedChart percentage={55} />
      <Button>
        Improve now
        <img src="/assets/icons/rightArrow.svg" alt="rightArrow" />
      </Button>
    </div>
  );
};
const MapCard = ({ mapKey, modal }) => {
  return (
    <div className="flex flex-1 shadow-xl">
      <Wrapper apiKey={mapKey} libraries={["places"]}>
        <FleetViewMap modal={modal} />
      </Wrapper>
    </div>
  );
};

const NotificationsCard = () => {
  return (
    <div className="flex flex-col items-start flex-1 justify-between p-5 gap-5 bg-white rounded-xl text-[#848484] leading-6 shadow-xl dark:bg-[#444444] dark:text-white">
      <div className="flex gap-5 justify-left">
        <Notification />
        <h1 className="h1 text-center dark:text-white">Notifications</h1>
      </div>
      <div>
        <div className="text-sm text-[#848484] font-semibold mb-2">
          09-06-2025
        </div>
        <div className="flex gap-4 mb-3">
          {/* Listing (vertical line) */}
          <div className="flex flex-col">
            <div className="h-full">
              <Listing />
            </div>
          </div>
          {/* Messages */}
          <div className="flex flex-col justify-between text-blue1 dark:text-white gap-4 w-full">
            <div>2.4 GHz: Switch to channel 11 </div>
            <div>5.0 GHz: Switch to channel 149</div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-sm text-[#848484] font-semibold mb-2">
          08-06-2025
        </div>
        <div className="flex gap-4 mb-3">
          {/* Listing (vertical line) */}
          <div className="flex flex-col">
            <div className="h-full">
              <Listing />
            </div>
          </div>
          {/* Messages */}
          <div className="flex flex-col justify-between text-blue1 dark:text-white gap-4 w-full">
            <div>Disconnect 2 devices for quality of experience</div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center mt-auto">
        <Button className="px-4 py-2 bg-[#5DA3E9] text-white font-bold rounded-md">
          See All Notifications
        </Button>
      </div>
    </div>
  );
};
const ConnectedDevicesCard = () => {
  return (
    <div className="flex flex-col p-4 gap-4 bg-white rounded-xl text-[#848484] leading-3 shadow-xl dark:bg-[#444444] dark:text-white">
      <div className="flex justify justify-left gap-5 items-center">
        <img src={connectedDevicesIcon} alt="" />
        <h1 className="h1 dark:text-white">Connected Devices</h1>
        <span className="text-[24px] font-[700] text-[#27403F] dark:text-white">
          {5}
        </span>
      </div>

      {/* <button className="mx-auto px-4 py-2  bg-[#5DA3E9] text-white font-bold rounded-md flex items-center justify-center">
        {"See All Devices "}
      </button> */}
    </div>
  );
};

const WeatherCard = () => {
  return (
    <div className="flex flex-col p-5 gap-5 bg-white rounded-xl dark:bg-[#444444] dark:text-white">
      <div className="flex justify justify-center gap-5 items-center">
        <CloudImg />
        <h1 className="font-bold text-xl">Chile</h1>
        <h1 className="font-bold text-2xl ">
          0.0° <span className="text-[#848484] text-xl">C</span>
        </h1>
      </div>

      <div className="grid grid-cols-2 gap-10 text-xl mt-4 justify-center pl-5 ">
        <div className="justify-center">
          <h3>Wind Speed</h3>
          <p className="text-3xl font-bold ">
            0 <span className="font-normal text-sm text-[#848484]">m/h</span>
          </p>
        </div>
        <div className="justify-center">
          <h3>Rain</h3>
          <p className="text-3xl font-bold ">
            0 <span className="font-normal text-sm text-[#848484]">mm</span>
          </p>
        </div>
        <div className="justify-center">
          <h3>Humidity</h3>
          <p className="text-3xl font-bold ">
            0 <span className="font-normal text-sm text-[#848484]">%</span>
          </p>
        </div>
        <div className="justify-center">
          <h3>Snowfall</h3>
          <p className="text-3xl font-bold ">
            0 <span className="font-normal text-sm text-[#848484]">mm</span>
          </p>
        </div>
      </div>
    </div>
  );
};

// IMPROVE THIS CARDS BELOWWWWWW
const DeviceProfileCard = () => {
  return (
    <div className="col-span-3 bg-box-pattern  rounded-xl p-4 flex-1 dark:bg-box-pattern2 border-white dark:border-black border-2">
      <h2 className="  text-center h1 dark:text-white ">Device Profile</h2>
      <div className="mt-5 grid grid-cols-3 gap-2 ">
        <div className="min-h-[170px] bg-white rounded-[8px] p-4 flex flex-col justify-start gap-2 items-center shadow-md dark:bg-[#444444]">
          <div className="text-[#27403F] dark:text-white mb-[17px] text-[14px] flex items-center gap-[10px] font-[700] mx-auto">
            {/* <img src={gatewatIcon} alt="gateway" className="w-5" /> */}
            <div className="w-6 h-6 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
              <img src={gatewatIcon} alt="gateway" className="w-4 h-4" />
            </div>
            Gateway
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-4">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                WanIP:
              </p>
            </div>

            <p className="text-[12px] text-[#333333] dark:text-white font-medium">
              {"10.74.175.243"}
            </p>
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-2">
            <div className="flex items-center gap-1">
              <p className="text-[12px] text-[#848484] leading-4 font-medium">
                Operations Status:
              </p>
            </div>

            <p className="text-[12px] font-medium text-[#333333] dark:text-white">
              {"Active"}
            </p>
          </div>
        </div>
        <div className="min-h-[170px] bg-white rounded-[8px] p-4 flex flex-col justify-start gap-2 items-center shadow-md dark:bg-[#444444]">
          <div className="text-[#27403F] dark:text-white mb-[17px] text-[14px] flex items-center gap-[10px] font-[700] mx-auto">
            <div className="w-6 h-6 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
              <img src={DeviceInfoIcon} alt="Device Info" className="w-4 h-4" />
            </div>
            Device Information
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-4">
            <div className=" mt-1 flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                Model:
              </p>
            </div>

            <p className="text-[12px] text-[#333333] dark:text-white font-medium">
              {"F6600P"}
            </p>
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-2">
            <div className="flex items-center gap-1">
              <p className="text-[12px] text-[#848484] leading-4 font-medium">
                Software:
              </p>
            </div>

            <p className="text-[12px] font-medium text-[#333333] dark:text-white">
              {"V9.0.10P6N51"}
            </p>
          </div>
        </div>
        <div className="min-h-[170px] bg-white rounded-[8px] p-4 flex flex-col justify-start gap-2 items-center shadow-md dark:bg-[#444444]">
          <div className="text-[#27403F] dark:text-white mb-[17px] text-[14px] flex items-center gap-[10px] font-[700] mx-auto">
            <div className="w-6 h-6 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
              <img src={signalIcon} alt="signal" className="w-4 h-4" />
            </div>
            Average Signal Strength
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-4">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                2.4 GHz:
              </p>
            </div>

            <p className="text-[12px] text-[#333333] dark:text-white font-medium">
              {"-59"}
              <span className="text-[10px] align-sub font-[500]"> dBm</span>
            </p>
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-2">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                5.0 GHz:
              </p>
            </div>

            <p className="text-[12px] font-medium text-[#333333] dark:text-white">
              {"-73"}
              <span className="text-[10px] align-sub font-[500]"> dBm</span>
            </p>
          </div>
        </div>
        <div className="min-h-[170px] bg-white rounded-[8px] p-4 flex flex-col justify-start gap-2 items-center shadow-md dark:bg-[#444444]">
          <div className="text-[#27403F] dark:text-white mb-[17px] text-[14px] flex items-center gap-[10px] font-[700] mx-auto">
            <div className="w-6 h-6 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
              <img src={ProductOriginIcon} alt="product" className="w-4 h-4" />
            </div>
            Product Origin
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-4">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                Manufacturer:
              </p>
            </div>

            <p className="text-[12px] text-[#333333] dark:text-white font-medium">
              {"ZTE"}
            </p>
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-2">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                Country:
              </p>
            </div>

            <p className="text-[12px] font-medium text-[#333333] dark:text-white">
              {"Chile"}
            </p>
          </div>
        </div>
        <div className="min-h-[170px] bg-white rounded-[8px] p-4 flex flex-col justify-start gap-2 items-center shadow-md dark:bg-[#444444]">
          <div className="text-[#27403F] dark:text-white text-[14px] mb-[17px] flex items-center gap-[10px] font-[700] mx-auto">
            <div className="w-6 h-6 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
              <img src={byteAndErrorIcon} alt="bytes" className="w-4 h-4" />
            </div>
            Streaming Bytes
          </div>

          <div className="flex gap-4 items-center justify-center">
            <div className="flex flex-col items-start">
              <div className="flex items-center gap-1 mb-4">
                <UpIcon w="16px" />
                <span className="text-[#27403F] dark:text-white text-[14px] ">
                  Upstream
                </span>
              </div>
              <div className="flex gap-2 justify-between items-center w-full mb-1">
                <div className="flex items-center gap-1">
                  <p className="text-[12px] font-medium text-[#848484] leading-4">
                    2.4 GHz:
                  </p>
                </div>

                <p className="text-[12px] font-medium text-[#333333] dark:text-white">
                  {179.91}
                  <span className="text-[10px] font-[500]"> GB</span>
                </p>
              </div>
              <div className="flex gap-2 justify-between items-center w-full mb-2">
                <div className="flex items-center gap-1">
                  {/* <DownIcon w="16px" /> */}
                  <p className="text-[12px] font-medium text-[#848484] leading-4">
                    5.0 GHz:
                  </p>
                </div>

                <p className="text-[12px] font-medium text-[#333333] dark:text-white">
                  {808.79}
                  <span className="text-[10px] font-[500]"> GB</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-start">
              <div className="flex items-center gap-1 mb-4">
                <DownIcon w="16px" />
                <span className="text-[#27403F] dark:text-white text-[14px] ">
                  Downstream
                </span>
              </div>
              <div className="flex gap-2 justify-between items-center w-full mb-1">
                <div className="flex items-center gap-1">
                  {/* <UpIcon w="16px" /> */}
                  <p className="text-[12px] font-medium text-[#848484] leading-4">
                    2.4 GHz:
                  </p>
                </div>

                <p className="text-[12px] font-medium text-[#333333] dark:text-white">
                  {7.05}
                  <span className="text-[10px] font-[500]"> GB</span>
                </p>
              </div>
              <div className="flex gap-2 justify-between items-center w-full mb-2">
                <div className="flex items-center gap-1">
                  {/* <DownIcon w="16px" /> */}
                  <p className="text-[12px] font-medium text-[#848484] leading-4">
                    5.0 GHz:
                  </p>
                </div>

                <p className="text-[12px] font-medium text-[#333333] dark:text-white">
                  {33.18}
                  <span className="text-[10px] font-[500]"> GB</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="min-h-[170px] bg-white rounded-[8px] p-4 flex flex-col justify-start gap-2 items-center shadow-md dark:bg-[#444444]">
          <div className="text-[#27403F] dark:text-white mb-[17px] text-[14px] flex items-center gap-[10px] font-[700] mx-auto">
            <div className="w-6 h-6 bg-gray-200 dark:bg-gray-600 rounded-full flex items-center justify-center">
              <img
                src={CurrentChannelIcon}
                alt="current channel"
                className="w-4 h-4"
              />
            </div>
            Current Channel
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-4">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                2.4 GHz:
              </p>
            </div>

            <p className="text-[12px] font-medium text-[#333333] dark:text-white">
              {13}
            </p>
          </div>
          <div className="flex gap-2 justify-between items-center w-full mb-2">
            <div className="flex items-center gap-1">
              <p className="text-[12px] font-medium text-[#848484] leading-4">
                5.0 GHz
              </p>
            </div>

            <p className="text-[12px] font-medium text-[#333333] dark:text-white">
              {157}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ConnectedDevicesProfileCard = () => {
  return (
    <div className="col-span-3 bg-box-pattern rounded-[8px] p-4 flex  flex-col gap-10 items-center flex-1 dark:bg-box-pattern2 border-white dark:border-black border-2">
      <h2 className="mb-[25px] h1 dark:text-white text-center">
        Connected Devices Profile
      </h2>
      <div className="w-[386px] h-[307.07px]  relative">
        <Device
          bottom="-307px"
          left="-78px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineBottom="-20px"
          lineLeft="31px"
          lineRotate="-108deg"
          lineHeight="223px"
          signalStrength={100}
          active={false}

          // active={conectedDeviceData?.Tablet_2}
          // signalStrength={conectedDeviceData?.Tablet2_signal_strength}
          // energy={conectedDeviceData?.Tablet2_Energy}
        />

        <Device
          bottom="-247px"
          left="-38px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineBottom="35px"
          lineLeft="51px"
          lineRotate="-98deg"
          lineHeight="180px"
          // active={conectedDeviceData?.Tablet_2}
          // signalStrength={conectedDeviceData?.Tablet2_signal_strength}
          // energy={conectedDeviceData?.Tablet2_Energy}
        />

        <Device
          bottom="-184px"
          left="-72px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineBottom="65px"
          lineLeft="31px"
          lineRotate="283deg"
          lineHeight="180px"
          signalStrength={25}
          active={true}
          // active={conectedDeviceData?.Tablet_1}
          // signalStrength={conectedDeviceData?.Tablet1_signal_strength}
          // energy={conectedDeviceData?.Tablet1_Energy}
        />

        <Device
          top="59px"
          left="-58px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="16px"
          lineLeft="28px"
          lineRotate="302deg"
          lineHeight="195px"
          signalStrength={100}
          active={false}
          // active={conectedDeviceData?.Mobile_2}
          // signalStrength={conectedDeviceData?.Mobile2_signal_strength}
          // energy={conectedDeviceData?.Mobile2_Energy}
        />
        <Device
          top="-19px"
          left="-14px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="-23px"
          lineLeft="55px"
          lineRotate="-33deg"
          lineHeight="195px"
          signalStrength={100}
          active={true}
          // active={conectedDeviceData?.Mobile_1}
          // signalStrength={conectedDeviceData?.Mobile1_signal_strength}
          // energy={conectedDeviceData?.Mobile1_Energy}
        />

        <Device
          top="-30px"
          left="100px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="20px"
          lineLeft="130px"
          lineRotate="-5deg"
          lineHeight="140px"
          // active={conectedDeviceData?.Mobile_1}
          // signalStrength={conectedDeviceData?.Mobile1_signal_strength}
          // energy={conectedDeviceData?.Mobile1_Energy}
        />
        <Device
          top="-30px"
          left="190px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="20px"
          lineLeft="170px"
          lineRotate="25deg"
          lineHeight="120px"
          signalStrength={100}
          active={true}
          // active={conectedDeviceData?.Mobile_1}
          // signalStrength={conectedDeviceData?.Mobile1_signal_strength}
          // energy={conectedDeviceData?.Mobile1_Energy}
        />

        <Device
          top="-25px"
          right="50px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="0px"
          lineRight="120px"
          lineRotate="59deg"
          lineHeight="160px"
          signalStrength={25}
          active={true}
          // active={conectedDeviceData?.Laptop_1}
          // signalStrength={conectedDeviceData?.Laptop1_signal_strength}
          // energy={conectedDeviceData?.Laptop1_Energy}
        />

        {/* <Device
          top="-15px"
          left="136px"
          srcOn={Smartbulb}
          srcOff={SmartbulbGray}
          srcLow={SmartbulbRed}
          lineSrc={line}
          lineTop="17px"
          lineLeft="141px"
          lineRotate="9deg"
          lineHeight="121px"
          // active={conectedDeviceData?.bulb}
          // signalStrength={conectedDeviceData?.bulb_signal_strength}
          // energy={conectedDeviceData?.bulb_Energy}
        /> */}

        {/* <Device
          top="147px"
          right="-60px"
          srcOn={laptop}
          srcOff={laptopGray}
          srcLow={laptopRed}
          lineSrc={line}
          lineTop="56px"
          lineRight="43px"
          lineRotate="110deg"
          lineHeight="205px"
          // active={conectedDeviceData?.Laptop_2}
          // signalStrength={conectedDeviceData?.Laptop2_signal_strength}
          // energy={conectedDeviceData?.Laptop2_Energy}
        /> */}

        {/* <Device
          bottom="-307px"
          left="-78px"
          srcOn={tablet}
          srcOff={tablet}
          srcLow={tabletRed}
          lineSrc={line}
          lineBottom="-20px"
          lineLeft="31px"
          lineRotate="-108deg"
          lineHeight="223px"
          // active={conectedDeviceData?.Tablet_2}
          // signalStrength={conectedDeviceData?.Tablet2_signal_strength}
          // energy={conectedDeviceData?.Tablet2_Energy}
        /> */}
        {/* <Device
          top="9px"
          left="200px"
          srcOn={tv}
          srcOff={tv}
          srcLow={tvRed}
          lineSrc={line}
          lineTop="45px"
          lineRight="170px"
          lineRotate="32deg"
          lineHeight="96px"
          // active={conectedDeviceData?.Television_1}
          // signalStrength={conectedDeviceData?.Television1_signal_strength}
          // energy={conectedDeviceData?.Television1_Energy}
        />

        <Device
          top="-40px"
          left="171px"
          srcOn={tv}
          srcOff={tvGray}
          srcLow={tvRed}
          lineSrc={line}
          lineTop="-2px"
          lineRight="180px"
          lineRotate="20deg"
          lineHeight="135px"
          // active={conectedDeviceData?.Television_2}
          // signalStrength={conectedDeviceData?.Television2_signal_strength}
          // energy={conectedDeviceData?.Television2_Energy}
        /> */}
        <Device
          top="40px"
          right="0px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="40px"
          lineRight="100px"
          lineRotate="78deg"
          lineHeight="140px"
          signalStrength={100}
          active={false}
          // active={conectedDeviceData?.Air_Conditioner}
          // signalStrength={conectedDeviceData?.Air_Conditioner_signal_strength}
          // energy={conectedDeviceData?.Air_Conditioner_Energy}
        />
        <Device
          top="122px"
          right="-20px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineTop="60px"
          lineRight="82px"
          lineRotate="105deg"
          lineHeight="170px"
          // active={conectedDeviceData?.washmachine}
          // signalStrength={conectedDeviceData?.washmachine_signal_strength}
          // energy={conectedDeviceData?.washmachine_Energy}
        />
        <Device
          bottom="-242px"
          right="-10px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineBottom="61px"
          lineRight="110px"
          lineRotate="121deg"
          lineHeight="165px"
          signalStrength={100}
          active={true}
          // active={conectedDeviceData?.Refrigerator}
          // signalStrength={conectedDeviceData?.Refrigerator_signal_strength}
          // energy={conectedDeviceData?.Refrigerator_Energy}
        />
        <Device
          bottom="-330px"
          right="15px"
          srcOn={deviceBLue}
          srcOff={deviceGray}
          srcLow={deviceYellow}
          lineSrc={line}
          lineBottom="-6px"
          lineRight="87px"
          lineRotate="145deg"
          lineHeight="188px"
          signalStrength={100}
          active={false}
          // active={conectedDeviceData?.AirPurifier}
          // signalStrength={conectedDeviceData?.AirPurifier_signal_strength}
          // energy={conectedDeviceData?.AirPurifier_Energy}
        />
        {/*         
        <Device
          bottom="-229px"
          left="12px"
          srcOn={DishWasher}
          srcOff={DishwasherGray}
          srcLow={DishWasherRed}
          lineSrc={line}
          lineBottom="81px"
          lineLeft="86px"
          lineRotate="263deg"
          lineHeight="116px"
          // active={conectedDeviceData?.DishWasher}
          // signalStrength={conectedDeviceData?.DishWasher_signal_strength}
          // energy={conectedDeviceData?.DishWasher_Energy}
        /> */}
        {/* <Device
          top="116px"
          left="-2px"
          srcOn={CCTV}
          srcOff={CCTVGray}
          srcLow={CCTVRed}
          lineSrc={line}
          lineTop="70px"
          lineLeft="65px"
          lineRotate="-72deg"
          lineHeight="142px"
          // active={conectedDeviceData?.Camera_1}
          // signalStrength={conectedDeviceData?.Camera1_signal_strength}
          // energy={conectedDeviceData?.Camera1_Energy}
        /> */}
        {/* <Device
          top="48px"
          left="15px"
          srcOn={assistant}
          srcOff={assistantGray}
          srcLow={assistantRed}
          lineSrc={line}
          lineTop="50px"
          lineLeft="85px"
          lineRotate="-45deg"
          lineHeight="119px"
          // active={conectedDeviceData?.Home_assistance_system}
          // signalStrength={
          //   conectedDeviceData?.Home_assistance_system_signal_strength
          // }
          // energy={conectedDeviceData?.Home_assistance_system_Energy}
        /> */}
        {/* )} */}
        {/* alrt */}
        {/* {show.alert && ( */}
        {/* <Device
          top="16px"
          left="99px"
          srcOn={DoorBell}
          srcOff={DoorBellGray}
          srcLow={DoorBellRed}
          lineSrc={line}
          lineTop="48px"
          lineLeft="127px"
          lineRotate="-13deg"
          lineHeight="100px"
          // active={conectedDeviceData?.DoorBell}
          // signalStrength={conectedDeviceData?.DoorBell_signal_strength}
          // energy={conectedDeviceData?.DoorBell_Energy}
        /> */}

        <div>
          <img
            className="w-[auto] absolute top-[65%] z-10 left-[40%] translate-y-[-25%] translate-x-[-25%] "
            src={home}
            alt="home"
          />
          <img
            className="w-[auto] absolute top-[75%] left-[38%] translate-y-[-25%] translate-x-[-25%] "
            src={home2}
            alt="line"
          />
        </div>
        {/* )} */}
        {/* {show.router && ( */}
        {/* <img
        className="w-[auto] absolute top-[41%] left-[44%] translate-y-[-25%] translate-x-[-25%] "
        src={router}
      /> */}
        <div className="group">
          <div className="w-[auto] absolute top-[41%] left-[44%] translate-y-[-25%] translate-x-[-35%] z-10 bg-[#ACD6FF] rounded-md p-4 shadow-md">
            <img alt="wifi" src={wifi} />
          </div>
          <div className="hidden group-hover:block absolute top-[55%] left-[25%] bg-white border border-gray-300 p-4 z-10 rounded shadow-lg">
            <p>
              <strong>Signal Strength:</strong>{" "}
              {/* {Math.round(
                100 * conectedDeviceData.Access_point_signal_strength
              ) / 100}{" "} */}
              {0}
              dBm
            </p>
            <p>
              <strong>Data Usage:</strong>{" "}
              {/* {Math.round(100 * conectedDeviceData.Bandwidth_utilisation_pct) /
                100}{" "} */}
              {0}
              Mbps
            </p>
            <p className="mb-2">
              <strong>Energy:</strong>{" "}
              {/* {Math.round(100 * conectedDeviceData.Access_point_Energy) / 100}  */}
              {0}W
            </p>
          </div>
        </div>
        {/* )} */}
      </div>
      <ConnectedDevicesCard />
      {/* <div className="mx-auto px-[15px] mt-[5px] rounded-[8px] shadow-comman flex items-center justify-center">
        <Deviceslog />
        <h5 className="text-[16px] ml-[7px] font-[500] text-[#848484]">
          Total Data usage :
        </h5>
        <h2 className="text-[#333333] dark:text-white ml-auto text-[20px] font-[500]">
          0<span className="text-[12px] font-[500]">KB</span>{" "}
        </h2>
      </div> */}
    </div>
  );
};
